import { render, staticRenderFns } from "./IconFaceSad.vue?vue&type=template&id=151bed08&"
import script from "./IconFaceSad.vue?vue&type=script&lang=js&"
export * from "./IconFaceSad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports